// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
const firebaseConfig = {
  apiKey: "AIzaSyBBwniob8IznlOtQlPgaJsZrVhc62D0pe8",
  authDomain: "solvemycodeissue.firebaseapp.com",
  projectId: "solvemycodeissue",
  storageBucket: "solvemycodeissue.firebasestorage.app",
  messagingSenderId: "758793459381",
  appId: "1:758793459381:web:fbed7793eee4fa485790fc",
  measurementId: "G-FQVXLJ2Z1H",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();
